import RiderPayouts from "../../../views/DriverSupport/RiderPayouts";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const DriverSupportRoutes = [
  {
    menuName: MenuNames.CITY,
    path: "/rider-payouts",
    component: RiderPayouts,
    exact: true,
  },
];

export default DriverSupportRoutes;
